const info = 
{
    title: "Y",
    type: "Short Film"
};

export default info;